import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, ShoppingCart, Flame } from 'lucide-react';
export function UrgencyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const [showPurchase, setShowPurchase] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const pricingSection = document.getElementById('pricing');
      if (!pricingSection) return;
      const rect = pricingSection.getBoundingClientRect();
      // Show when pricing section is near the top or visible
      if (rect.top < 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        setShowPurchase(true);
        // Hide after 5 seconds
        setTimeout(() => setShowPurchase(false), 5000);
      }, 4000); // Show after 4 seconds of being visible
      return () => clearTimeout(timer);
    }
  }, [isVisible]);
  return <AnimatePresence data-id="element-289">
      {isVisible && <motion.div initial={{
      y: -100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: -100,
      opacity: 0
    }} className="fixed top-12 left-0 right-0 z-[65] flex flex-col items-center pointer-events-none px-4" data-id="element-290">
          <div className="bg-white rounded-[24px] py-2 px-6 shadow-xl border border-gray-100 flex flex-col gap-1 pointer-events-auto max-w-fit" data-id="element-291">
            <div className="flex items-center gap-3 text-[#4c1d95] font-black text-[10px] md:text-[11px] uppercase tracking-wide" data-id="element-292">
              <div className="w-2 h-2 rounded-full bg-[#22c55e] shadow-[0_0_8px_rgba(34,197,94,0.6)]" data-id="element-293" />
              <Users className="w-3.5 h-3.5" data-id="element-294" />
              <span data-id="element-295">27 personas mirando</span>
            </div>
            <div className="flex items-center gap-3 text-[#4c1d95] font-black text-[10px] md:text-[11px] uppercase tracking-wide" data-id="element-296">
              <div className="w-2 h-2 rounded-full bg-[#ef4444] shadow-[0_0_8px_rgba(239,68,68,0.6)]" data-id="element-297" />
              <Flame className="w-3.5 h-3.5" data-id="element-298" />
              <span data-id="element-299">Cupos disponibles: 7</span>
            </div>
          </div>

          <AnimatePresence data-id="element-300">
            {showPurchase && <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: -10
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.9,
          y: -10
        }} className="w-full max-w-[300px] mt-2 pointer-events-auto" data-id="element-301">
                <div className="bg-[#16a34a] text-white rounded-full py-2 px-5 flex items-center justify-center gap-2 font-black text-[10px] uppercase tracking-wider shadow-[0_4px_15px_rgba(22,163,74,0.3)]" data-id="element-302">
                  <ShoppingCart className="w-3.5 h-3.5" data-id="element-303" />
                  <span data-id="element-304">¡Alguien acaba de comprar!</span>
                </div>
              </motion.div>}
          </AnimatePresence>
        </motion.div>}
    </AnimatePresence>;
}